module.exports = __webpack_public_path__ + "img/information-warning.8dba4fad.svg";